/**
 * Formati (fogli) su cui puo' essere generata la griglia provino.
 *
 * Provino Format Naming Convention
 *
 * Custom layout IDs follow this pattern:
 *   taglierina-{format}-{mt}{value}-{ml}{value}-{sh}{value}-{sv}{value}
 *
 * Where:
 *   - format: Paper format and orientation (e.g., a4o = A4 Orizzontale, a4v = A4 Verticale)
 *   - mt: Margin Top in mm (e.g., mt175 = 17.5mm)
 *   - ml: Margin Left in mm (e.g., ml15 = 15mm)
 *   - sh: Spacing Horizontal (between columns) in mm (e.g., sh3 = 3mm)
 *   - sv: Spacing Vertical (between rows) in mm (e.g., sv2 = 2mm)
 *
 * Example:
 *   taglierina-a4o-mt175-ml15-sh3-sv2
 *   = Taglierina A4 Orizzontale, margin top 17.5mm, margin left 15mm,
 *     horizontal spacing 3mm, vertical spacing 2mm
 *
 * Note: Decimal values omit the dot (e.g., 17.5 becomes 175)
 */

export const provinoFormats = [
  {
    id: 'a4V',
    text: 'A4 Verticale',
    width: 210,
    height: 297,
    orientation: 'p',
  },
  {
    id: 'a4O',
    text: 'A4 Orizzontale',
    width: 297,
    height: 210,
    orientation: 'l',
  },
  {
    id: 'a3V',
    text: 'A3 Verticale',
    width: 297,
    height: 420,
    orientation: 'p',
  },
  {
    id: 'a3O',
    text: 'A3 Orizzontale',
    width: 420,
    height: 297,
    orientation: 'l',
  },
  {
    id: 'a5-verticale',
    text: 'A5 Verticale',
    width: 148,
    height: 210,
    orientation: 'p',
  },
  {
    id: 'a5-orizzontale',
    text: 'A5 Orizzontale',
    width: 210,
    height: 148,
    orientation: 'l',
  },
  {
    id: '48x32',
    text: '32 x 48 Verticale',
    width: 320,
    height: 480,
    orientation: 'p',
  },
  {
    id: '32x48',
    text: '32 x 48 Orizzontale',
    width: 480,
    height: 320,
    orientation: 'l',
  },
  {
    id: 'card',
    text: 'CARD',
    width: 55,
    height: 85,
    orientation: 'p',
    disabled: false,
  },
  {
    id: 'ricordino-153x313',
    text: 'CP 5000',
    caption: 'Foglio verticale 153×313,5mm',
    width: 153,
    height: 313.5,
    orientation: 'p',
    disabled: false,
  },
  {
    // custom layout, handled in customLayouts/ricordino-152x102-cp5000.js
    // Misure della pagina del driver, non della carta 10 x 15: l'id resta
    // quello del primo rilascio perche' e' salvato nelle impostazioni export.
    id: 'ricordino-152x102-cp5000',
    text: 'CP 5000 (10 x 15)',
    caption:
      'Foglio orizzontale 157,82×103,63mm · 2 ricordini 6×9cm negli angoli in basso',
    width: 157.82,
    height: 103.63,
    orientation: 'l',
    disabled: false,
    allowUserToManageMargins: false,
  },
  {
    // custom layout, handled in customLayouts/auto-cut-cc-150.js
    id: 'auto-cut-cc-150',
    text: 'Auto Cut CC-150',
    width: 297,
    height: 210,
    orientation: 'l',
    allowUserToManageMargins: false,
  },
  {
    // custom layout, handled in customLayouts/auto-cut-cc-150-10UP-landscape.js
    id: 'auto-cut-cc-150-10UP-landscape',
    text: 'Auto Cut CC-150 10 UP (Orizzontale)',
    width: 297,
    height: 210,
    orientation: 'l',
    allowUserToManageMargins: false,
  },
  {
    // custom layout, handled in customLayouts/ricordino-57x88.js
    id: 'ricordino-57x88',
    text: '57 x 88 mm',
    width: 297,
    height: 210,
    orientation: 'l',
    disabled: false,
    allowUserToManageMargins: false,
  },
  {
    // custom layout, handled in customLayouts/ricordino-130x180.js
    id: 'ricordino-130x180',
    text: '130 x 180 mm',
    width: 130,
    height: 180,
    orientation: 'p',
    disabled: false,
    allowUserToManageMargins: false,
  },
  {
    id: 'ricordino-150x308',
    text: '150 x 308 mm',
    width: 150,
    height: 308,
    orientation: 'p',
    disabled: false,
  },
  {
    id: 'ricordino-203x303',
    text: '203 x 303 mm',
    width: 203,
    height: 303,
    orientation: 'p',
    disabled: false,
  },
  {
    id: 'ricordino-154x103',
    text: '154 x 103 mm',
    width: 154,
    height: 103,
    orientation: 'l',
    disabled: false,
  },
  {
    id: 'ricordino-148x100',
    text: '148 x 100 mm',
    width: 148,
    height: 100,
    orientation: 'l',
    disabled: false,
  },
  {
    // custom layout, handled in customLayouts/ricordino-148x100-d500-d1000.js
    id: 'ricordino-148x100-d500-d1000',
    text: '148 x 100 mm (D500-D1000)',
    width: 148,
    height: 100,
    orientation: 'l',
    disabled: false,
    allowUserToManageMargins: false,
  },
  {
    id: 'ricordino-150x100',
    text: '150 x 100 mm',
    width: 150,
    height: 100,
    orientation: 'l',
    disabled: false,
  },
  {
    // custom layout, handled in customLayouts/taglierina-a4o-mt175-ml15-sh3-sv2.js
    id: 'taglierina-a4o-mt175-ml15-sh3-sv2',
    text: 'Taglierina A4 Orizzontale',
    caption: 'Margini: alto 17.5mm, sinistra 15mm · Spaziatura: 3×2mm',
    width: 297,
    height: 210,
    orientation: 'l',
    disabled: false,
    allowUserToManageMargins: false,
  },
  {
    // custom layout, handled in customLayouts/taglierina-a4o-centered.js
    id: 'taglierina-a4o-centered',
    text: 'Taglierina A4 Orizzontale (centrato)',
    caption: 'Gruppo centrato · Senza spaziatura tra righe e colonne',
    width: 297,
    height: 210,
    orientation: 'l',
    disabled: false,
    allowUserToManageMargins: false,
  },
];

/**
 * Formato custom con la configurazione (leve) della taglierina Memento di
 * Santini, riservato alle organizzazioni autorizzate (vedi
 * taglierinaMementoSantiniAccess.js).
 *
 * NON e' un formato generico "taglierina Memento": e' la messa a punto di un
 * singolo cliente. Chi ha la stessa macchina ma impostata diversamente deve
 * avere una voce e un id propri, non riusare questa.
 *
 * Il nome del cliente resta in id, modulo e commenti, ma NON in `text` ne' in
 * `caption`: in menu l'utente vede solo "Taglierina Memento" con la
 * descrizione tecnica del formato. La caption compare anche nella voce
 * selezionata (text + caption), quindi non deve contenere etichette interne.
 */
export const TAGLIERINA_MEMENTO_SANTINI_FORMAT_ID =
  'taglierina-memento-santini';

export const taglierinaMementoSantiniFormat = {
  // custom layout, handled in customLayouts/taglierina-memento-santini.js
  id: TAGLIERINA_MEMENTO_SANTINI_FORMAT_ID,
  text: 'Taglierina Memento',
  caption: 'Ricordini 5,7×8,8cm · 10 per foglio A4',
  width: 297,
  height: 210,
  orientation: 'l',
  disabled: false,
  allowUserToManageMargins: false,
};

export const getProvinoFormats = ({ canUseTaglierinaMemento = false } = {}) =>
  canUseTaglierinaMemento
    ? [...provinoFormats, taglierinaMementoSantiniFormat]
    : provinoFormats;
